import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    height: 50px;

    & > :last-child {
        // Big button has larger spacing
        margin-left: 15px;
    }

    & > :not(:last-child):not(:first-child) {
        margin-left: 5px;
    }
`;

export const ImportButton = styled.div`
    padding: 0 15px 0 10px;
`;
